import { render, staticRenderFns } from "./MelamineDetail.vue?vue&type=template&id=3968d2ae&scoped=true"
import script from "./MelamineDetail.vue?vue&type=script&lang=js"
export * from "./MelamineDetail.vue?vue&type=script&lang=js"
import style0 from "./MelamineDetail.vue?vue&type=style&index=0&id=3968d2ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968d2ae",
  null
  
)

export default component.exports